/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Contract_Phases_RequiredInputs */

const en_clients_validation_contract_phases_required = /** @type {(inputs: Clients_Validation_Contract_Phases_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least one phase for this case type.`)
};

const pt_br2_clients_validation_contract_phases_required = /** @type {(inputs: Clients_Validation_Contract_Phases_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione ao menos uma fase para este tipo de caso.`)
};

/**
* | output |
* | --- |
* | "Select at least one phase for this case type." |
*
* @param {Clients_Validation_Contract_Phases_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_contract_phases_required = /** @type {((inputs?: Clients_Validation_Contract_Phases_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Contract_Phases_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_contract_phases_required(inputs)
	return pt_br2_clients_validation_contract_phases_required(inputs)
});